// getters.js

export default {
    getCurrentUser(state){
        return state.currentUser
    }
};
